export type NetworkTraceInfo = {
	requestId?: string;
	traceId?: string;
};

const NOT_AVAILABLE = 'not_available';

/**
 * Extracts trace info from an AggResponse-shaped result that may contain
 * extensions.gateway.request_id and extensions.gateway.trace_id.
 */
export const extractTraceInfoFromResponse: (result: unknown) => NetworkTraceInfo | undefined = (result: unknown): NetworkTraceInfo | undefined => {
	if (result && typeof result === 'object' && 'extensions' in result) {
		const extensions = (result as any).extensions;
		const gateway = extensions?.gateway;
		if (gateway) {
			return {
				requestId: gateway.request_id ?? undefined,
				traceId: gateway.trace_id ?? undefined,
			};
		}
	}
	return undefined;
};

/**
 * Normalises trace info so that missing values are replaced with a sentinel
 * string ('not_available') that is distinguishable from "field not present in
 * the payload" when querying Databricks.
 */
export const normaliseTraceInfo: (traceInfo?: NetworkTraceInfo) => {
    requestId: string;
    traceId: string;
} = (traceInfo?: NetworkTraceInfo) => ({
	requestId: traceInfo?.requestId ?? NOT_AVAILABLE,
	traceId: traceInfo?.traceId ?? NOT_AVAILABLE,
});
